import React, { useImperativeHandle, forwardRef, useState } from 'react';
import { validateInit, validateForm } from '@assets/js/util/formValidation.js';
import { formAtt } from '@assets/js/util/commonUtil.js';
import CompFmtInput from '@components/form/fragment/comp-fmt-input.js';
import CompFmtSelectbox from '@components/form/fragment/comp-fmt-selectbox.js';
import {ApiSave} from '@assets/js/api/commonApi.js';

const CompFormDivision = forwardRef((props, ref) => {
    const [params, setParams] = useState({});
    const [title, setTitle] = useState('부문정보 등록/수정');
    
    /****************************
     * Define required variables
    *****************************/
    const rooId = 'modalSheet';
    const validateOpt = {
        scopeEle: document.querySelector('#' + rooId),
        targetIds: ['dvsnGrpCd', 'dvsnGrpNm', 'dvsnNm'],
        params: params,
    }

    /*************************
     * Define react functions
    **************************/
    // Forward ref to allow parent components to call event functions.
    useImperativeHandle(ref, () => ({
        modalToggle(p_params) {
            handleToggle();
            handleValue(p_params);
            setParams(p_params || {});
        },
    }));

    /**********************
     * Define functions
    ***********************/
    const handleValue = (p_params) => {
        const targetEle = document.querySelector('#' + rooId);

        // Handle disable logic for modify
        const dvsnGrpCdEle = targetEle.querySelector('#dvsnGrpCd');
        const dvsnGrpNmEle = targetEle.querySelector('#dvsnGrpNm');
        if (p_params.dvsnGrpCd !== undefined && p_params.dvsnGrpCd !== '') {
            if (dvsnGrpNmEle) dvsnGrpNmEle.disabled = false;
            setTitle('부문 정보 수정');
        } else {
            if (dvsnGrpNmEle) dvsnGrpNmEle.disabled = false;
            setTitle('부문정보 등록');
        }

        if (dvsnGrpCdEle) dvsnGrpCdEle.disabled = true;

        // Handle change value logic for isGrp case
        if (p_params && p_params.isGrp !== undefined && p_params.isGrp) {
            p_params.mode = 'I';
            p_params.dvsnCd = '';
            p_params.dvsnNm = '';
            p_params.remark = '';
            p_params.useYn = '';
            p_params.sortNo = '';
            setTitle('부문코드 추가 등록');

            if (dvsnGrpNmEle) dvsnGrpNmEle.disabled = true;
        }
    }
    const handleToggle = () => {
        const targetEle = document.querySelector('#' + rooId);
        if (targetEle) {
            targetEle.style.display = targetEle.style.display === 'none' ? 'block' : 'none';
        }

        // Reset form inputs and validation state
        validateInit(validateOpt);

        Object.keys(formObj).forEach(key => {
            const ele = targetEle.querySelector(`#${formObj[key].id}`);
            if (ele) { ele.value = ''; }
        });
    }
    const onSave = () => {
        // Validate form inputs before saving
        if (!validateForm(validateOpt)) { return; }

        // Fetch data from the server
        ApiSave('/sys/dvsnmng/save/info', params).then(res => {
            if (res && res.success) {
                // Close the modal after saving
                handleToggle();
                // Search for updated data
                props.onGridSearch();
            }
        });
    }
    const onValChange = (e) => {
        const { id } = e.target;
        // Validate the specific input field
        validateForm(validateOpt, id);
    }
    const onInputChange = (e) => {
        const { id, value } = e.target;
        // Update the state with the new value only (no validation)
        setParams({ ...params, [id]: value });
    }

    /****************************
     * Define form config
    *****************************/
    const formObj = {
        dvsnGrpCd : formAtt({id: 'dvsnGrpCd', label: '부문그룹코드', value: params['dvsnGrpCd'] || '', disabled: true, classCol: 'col-6'}),
        dvsnGrpNm : formAtt({id: 'dvsnGrpNm', label: '부문그룹명', value: params['dvsnGrpNm'] || '', required: true, maxLength: 50, classCol: 'col-6'}),
        dvsnCd    : formAtt({id: 'dvsnCd', label: '부문코드', value: params['dvsnCd'] || '', disabled: true, classCol: 'col-6'}),
        dvsnNm    : formAtt({id: 'dvsnNm', label: '부문명', value: params['dvsnNm'] || '', required: true, maxLength: 50, classCol: 'col-6'}),
        remark    : formAtt({id: 'remark', label: '설명', value: params['remark'] || '', maxLength: 100}),
        sortNo    : formAtt({id: 'sortNo', label: '순서', value: params['sortNo'] || '', maxLength: 2, classCol: 'col-3'}),
        useYn     : formAtt({id: 'useYn', label: '사용여부', value: params['useYn'] || '', required: true, classCol: 'col-3'}),
    }

    return (
        <>
            <div 
                className="modal modal-sheet p-1 py-md-5"
                style={{ display: 'none', backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
                tabIndex={-1}
                role="dialog"
                id={rooId}
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content rounded-4 shadow">
                        <div className="modal-header border-bottom-0">
                            <h1 className="modal-title fs-5">{title}</h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={handleToggle}
                            />
                        </div>
                        <div className="modal-body py-0">
                            <div className="row g-5">
                                <div className="col-lg-12">
                                    <form className="needs-validation" noValidate="">
                                        <div className="row">
                                            <div className="bg-light p-3 rounded">
                                                <div className="row">
                                                    <CompFmtInput
                                                        attrs={formObj.dvsnGrpCd}
                                                        onChange={onInputChange}
                                                        onBlur={onValChange}
                                                    />
                                                    <CompFmtInput
                                                        attrs={formObj.dvsnGrpNm}
                                                        onChange={onInputChange}
                                                        onBlur={onValChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="p-3 rounded">
                                                <div className="row mb-2">
                                                    <CompFmtInput
                                                        attrs={formObj.dvsnCd}
                                                    />
                                                    <CompFmtInput
                                                        attrs={formObj.dvsnNm}
                                                        onChange={onInputChange}
                                                        onBlur={onValChange}
                                                    />
                                                </div>
                                                <div className="row mb-2">
                                                    <CompFmtInput
                                                        attrs={formObj.remark}
                                                        onChange={onInputChange}
                                                        onBlur={onValChange}
                                                    />
                                                </div>
                                                <div className="row mb-2">
                                                    <CompFmtInput
                                                        attrs={formObj.sortNo}
                                                        onChange={onInputChange}
                                                        onBlur={onValChange}
                                                    />
                                                    <CompFmtSelectbox 
                                                        attrs={formObj.useYn}
                                                        grpCd={"GRP001"}
                                                        selectType={"S"}
                                                        onChange={(e) => {
                                                            const { id, value } = e.target;
                                                            setParams({ ...params, [id]: value });
                                                            validateForm(validateOpt, id);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer flex-column align-items-stretch w-100 gap-2 pb-3 border-top-0">
                            <div className="btn-group">
                                <button type="button" className="btn btn-lg btn-primary" onClick={onSave}>
                                    Save changes
                                </button>
                                <button type="button" className="btn btn-lg btn-secondary" data-bs-dismiss="modal" onClick={handleToggle}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </> 
    );
});

export default CompFormDivision;